import { GetBetDetailByRefNoResponse } from '../../models';

export const getBetDetailByRefNoMock: GetBetDetailByRefNoResponse = {
	returnCode: '0',
	message: '',
	url: 'https://2ios0nzxkx24qp5.highplayfky.com/cashorcrashbetdetail/?lang=&payload=T2Uh5gkhnSsz7oN0SlBr%2fxwZWB2fuFgn1ocTa8WZkc8Hiaj7prJdIvJvvWI2HTbOqtfJTgtyBsGd770LPTNIjg%3d%3d&time=081520220720',
};

export default getBetDetailByRefNoMock;
